import type { MilestoneCategory } from '../lib/planner';

// =============================================================================
// Milestone category colors (v0.2.34)
//
// One color per task category — the planner color-codes by category (not by
// source scholarship), so the legend stays small and learnable.
// =============================================================================

interface CategoryStyle {
  dot: string;     // background for the color dot / chip
  chip: string;    // bg + text for a category chip
  bar: string;     // left-border accent for an agenda row
}

export const CATEGORY_STYLES: Record<MilestoneCategory, CategoryStyle> = {
  essay: {
    dot: 'bg-forest-600',
    chip: 'bg-forest-100 text-forest-800',
    bar: 'border-l-forest-400',
  },
  recommendation: {
    dot: 'bg-amber-500',
    chip: 'bg-amber-100 text-amber-800',
    bar: 'border-l-amber-400',
  },
  transcript_scores: {
    dot: 'bg-sky-500',
    chip: 'bg-sky-100 text-sky-800',
    bar: 'border-l-sky-400',
  },
  portfolio: {
    dot: 'bg-pink-500',
    chip: 'bg-pink-100 text-pink-800',
    bar: 'border-l-pink-400',
  },
  submit: {
    dot: 'bg-emerald-600',
    chip: 'bg-emerald-100 text-emerald-800',
    bar: 'border-l-emerald-500',
  },
  admission: {
    dot: 'bg-violet-600',
    chip: 'bg-violet-100 text-violet-800',
    bar: 'border-l-violet-500',
  },
};
